import { computePosition, autoUpdate, offset } from "@floating-ui/dom"

function findScrollContainer(element) {
  let current = element.parentElement
  while (current) {
    const overflowY = getComputedStyle(current).overflowY
    if (overflowY === "auto" || overflowY === "scroll") return current
    current = current.parentElement
  }
  return document.scrollingElement
}

function showPopover() {
  const targetElement = this.targetElements[0]

  let placement
  const alignment = this.getAttribute("alignment")

  switch(alignment) {
    case "left":
      placement = "bottom-start"
      break
    case "right":
      placement = "bottom-end"
      break
    default:
      throw new Error(`Unsupported alignment: ${alignment}. (left|right)`)
  }

  const fragment = this.templateElement.content.cloneNode(true)
  const popoverElement = fragment.firstElementChild

  document.body.appendChild(popoverElement)

  const scrollingElement = findScrollContainer(targetElement)
  const spacerElement = document.createElement("div")
  scrollingElement.appendChild(spacerElement)

  let disableAutoUpdate = null

  popoverElement.addEventListener("toggle", (event) => {
    if (event.newState === "closed") {
      if (disableAutoUpdate) {
        disableAutoUpdate()
      }
      popoverElement.remove()

      if (spacerElement.offsetHeight === 0) {
        spacerElement.remove()
        return
      }

      const maxScrollWithoutSpacer = scrollingElement.scrollHeight - spacerElement.offsetHeight - scrollingElement.clientHeight
      const targetScrollTop = Math.max(0, Math.min(scrollingElement.scrollTop, maxScrollWithoutSpacer))

      if (targetScrollTop === scrollingElement.scrollTop) {
        spacerElement.remove()
        return
      }

      const cleanup = () => {
        scrollingElement.removeEventListener("scrollend", cleanup)
        spacerElement.remove()
      }

      scrollingElement.addEventListener("scrollend", cleanup)
      scrollingElement.scrollTo({ top: targetScrollTop, behavior: "smooth" })
    }
  })

  popoverElement.showPopover()

  const triggerRect = targetElement.getBoundingClientRect()
  const contentRect = scrollingElement.getBoundingClientRect()
  const popoverOffset = 8
  const windowBottomPadding = 12
  const overflow = triggerRect.bottom + popoverElement.offsetHeight + popoverOffset + windowBottomPadding - contentRect.bottom
  if (overflow > 0) {
    const availableScroll = scrollingElement.scrollHeight - scrollingElement.scrollTop - scrollingElement.clientHeight
    const spacerHeight = Math.max(0, overflow - availableScroll)
    if (spacerHeight > 0) {
      spacerElement.style.height = `${spacerHeight}px`
    }
    scrollingElement.scrollBy({ top: overflow, behavior: "smooth" })
  }

  disableAutoUpdate = autoUpdate(targetElement, popoverElement, () => {
    computePosition(targetElement, popoverElement, {
      placement,
      strategy: "fixed",
      middleware: [offset(popoverOffset)]
    }).then(({ x, y }) => {
      popoverElement.style.left = `${x}px`
      popoverElement.style.top = `${y}px`
    })
  })
}

export function activate(Turbo) {
  Turbo.StreamActions.show_popover = showPopover
}
